import { FormControl, FormHelperText, Box, Typography } from "@mui/material"
import BaseCheckbox from "components/base/Checkbox"
import useCheckbox from "hooks/use_checkbox"
import BaseLink from "../../base/Link"
import useTranslation from "../../../hooks/use_translation"

const TermsAndConditions = () => {
  const id = "terms_and_conditions"
  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === false) return fields?.terms_and_co_error_not_agreed

    return ""
  }

  const { handleChange, inputValue, errorMessage } = useCheckbox(id, validate)

  const CheckboxLabel = () => (
    <Typography variant="body2" sx={{ mt: 0.5 }}>
      <Typography component="span" sx={{ mr: 1 }}>
        {fields?.terms_and_co_title}
      </Typography>
      <BaseLink path="/terms_and_conditions">{fields?.terms_and_co_link}</BaseLink>
    </Typography>
  )

  return (
    <FormControl error={errorMessage?.length > 0}>
      <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2.5 }}>
        <BaseCheckbox checked={inputValue} onChange={handleChange} />
        <CheckboxLabel />
      </Box>
      <FormHelperText sx={{ ml: 5 }}>{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default TermsAndConditions
